import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timeBasedOptions"]
  
  connect() {
    // Ensure proper initial state
    this.toggleTimeBasedVisibility()
  }
  
  toggleTimeBasedVisibility() {
    const timeBasedCheckbox = this.element.querySelector('input[type="checkbox"][name*="work_logging_time_based"]')
    const timeBasedOptions = this.timeBasedOptionsTarget
    
    if (timeBasedCheckbox && timeBasedOptions) {
      if (timeBasedCheckbox.checked) {
        timeBasedOptions.classList.remove('hidden')
      } else {
        timeBasedOptions.classList.add('hidden')
      }
    }
  }
} 